module.exports = __webpack_public_path__ + "img/About us page.63dc4500.png";